module.exports = "//static.hsappstatic.net/salesImages/static-1.403/prospects/prospects.svg"